import { useTranslation } from '@web_opxp/features';
import { Link } from 'react-router-dom';

interface Props {
  email: string;
}

export default function PasswordForgotLink({ email }: Props) {
  const { t } = useTranslation();
  return (
    <div className="mt-3">
      <Link
        to={{
          pathname: '/forgot',
          state: { email },
        }}>
        {t('Login.Forgot')}
      </Link>
    </div>
  );
}
